(function () {
  function setupLane(lane) {
    var track = lane.closest('.track') || lane.parentElement;
    var first = lane.querySelector('.set');
    if (!track || !first) return;

    if (!lane.dataset.mqFilled) {
      var minWidth = Math.max(track.clientWidth * 2, first.offsetWidth * 2, 1);
      var guard = 0;
      while (lane.scrollWidth < minWidth && guard < 8) {
        var clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        lane.appendChild(clone);
        guard += 1;
      }
      lane.dataset.mqFilled = '1';
    }

    var width = first.getBoundingClientRect().width;
    if (width > 1) {
      lane.style.setProperty('--mq-x', width + 'px');
      lane.style.setProperty('--mq-s', Math.max(16, Math.round(width / 50)) + 's');
    }
  }

  function init() {
    document.querySelectorAll('.mh-trusted-marquee').forEach(setupLane);
  }

  function initWhenReady() {
    init();
    document.querySelectorAll('.mh-trusted-marquee img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', init, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }

  window.addEventListener('resize', init);
  document.addEventListener('shopify:section:load', initWhenReady);
})();
